import { parseISO, formatDistanceToNow } from "date-fns";

/**
 * Formats a timestamp into a human-readable relative time string
 * Example: "2 hours ago", "a day ago", "3 minutes ago"
 * @param timestamp ISO 8601 formatted timestamp string
 * @returns Relative time string (e.g., "2 hours ago")
 */
export const formatRelativeTime = (timestamp: string): string => {
    try {
        const date = parseISO(timestamp);
        return formatDistanceToNow(date, { addSuffix: true });
    } catch (error) {
        console.error(`Failed to format timestamp: ${timestamp}`, error);
        return "";
    }
};
